/**
 * Servicio de Notificaciones
 *
 * Gestiona las llamadas HTTP relacionadas con notificaciones
 */

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5513/api";

/**
 * Obtener headers con Authorization token
 */
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Obtener notificaciones del usuario autenticado
 */
export const getMyNotifications = async (onlyUnread = false, limit = 50) => {
  try {
    const response = await axios.get(`${API_URL}/notifications`, {
      params: { onlyUnread, limit },
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

/**
 * Obtener contador de notificaciones no leídas
 */
export const getUnreadCount = async () => {
  try {
    const response = await axios.get(`${API_URL}/notifications/unread-count`, {
      headers: getAuthHeaders()
    });
    return response.data.data.unreadCount;
  } catch (error) {
    console.error("Error fetching unread count:", error);
    throw error;
  }
};

/**
 * Marcar notificación como leída
 */
export const markAsRead = async (notificationId) => {
  try {
    const response = await axios.patch(
      `${API_URL}/notifications/${notificationId}/read`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};

/**
 * Marcar todas las notificaciones como leídas
 */
export const markAllAsRead = async () => {
  try {
    const response = await axios.patch(
      `${API_URL}/notifications/read-all`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking all as read:", error);
    throw error;
  }
};

/**
 * Eliminar notificación
 */
export const deleteNotification = async (notificationId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/notifications/${notificationId}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting notification:", error);
    throw error;
  }
};

/**
 * Crear notificación (solo para testing/admin)
 */
export const createNotification = async (
  userId,
  title,
  message,
  type,
  entityType = null,
  entityId = null
) => {
  try {
    const response = await axios.post(
      `${API_URL}/notifications`,
      {
        userId,
        title,
        message,
        type,
        entityType,
        entityId
      },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating notification:", error);
    throw error;
  }
};

/**
 * Guardar token FCM del usuario
 */
export const saveFCMToken = async (fcmToken) => {
  try {
    const response = await axios.post(
      `${API_URL}/notifications/fcm-token`,
      { fcmToken },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving FCM token:", error);
    throw error;
  }
};

/**
 * Eliminar token FCM del usuario
 */
export const deleteFCMToken = async (fcmToken) => {
  try {
    const response = await axios.delete(
      `${API_URL}/notifications/fcm-token`,
      {
        headers: getAuthHeaders(),
        data: { fcmToken }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting FCM token:", error);
    throw error;
  }
};
